/**
 * 点状分布图层,使用featurelayer；支持大数据量渲染
 * Created by onsinsin on 2016/12/14.
 */
'use strict';
/**
 * 点状分布基类
 * @module FeaturePointLayer
 */
define([
    './DistributeLayer',
    '../utils/CommonUtil',
    '../utils/LoggerUtil',
    '../g2'
],function(
    DistributeLayer,
    CommonUtil,
    LoggerUtil,
    g2
){
    /**
     * 构造方法
     * @constructor
     * @classdesc 大数据量渲染点图层
     * @augments G.lys.DistributeLayer
     * @alias G.lys.FeaturePointLayer
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map/g2.carto.Map} options.map -必填，地图对象
     * @param {String} options.layerId - 可选，图层id，默认为随机字符串
     * @param {String} options.idKey - 必填，数据记录中作为唯一标识的字段名
     * @param {String} options.attributeField - 可选，数据记录中属性信息挂接的属性名，默认为空
     * @param {String} options.geometryField - 可选，数据记录中空间属性名，默认为空，如果有值，则几何使用数据记录中对应的坐标信息；
     * @param {String} options.xField - 可选，数据记录中x坐标字段名，默认为LONGITUDE
     * @param {String} options.yField - 可选，数据记录中y坐标字段名，默认为LATITUDE
     * @param {Object} options.symbolConfig - 必填，符号配置
     * @param {String} options.defaultSymbolKey - 可选，符号配置文件中默认符号的key值，默认为default
     * @param {Number} options.spatialReference - 可选，图层坐标系，默认4326
     * @param {Number} options.dataSpatialReference - 可选，叠加数据的坐标系，默认图层坐标系
     * @param {Function} options.symbolUpdateCallback - 可选，地图显示的符号更新时的回调，
     * @param {Object} options.callbackContext - 可选，回调的上下文
     * @returns {Class} - 实例化的对象
     */
    var layer=DistributeLayer.extend({
        options:{
            //默认配置
            symbolConfig:false,
            //经度字段名
            xField:'longitude',
            //纬度字段名
            yField:'latitude',
            //数据集的元数据信息
            metaData:{}
        },
        initialize:function(options){
            //没有坐标的数据
            this.noneSpatialArr=[];
            //显示的元素
            this.features=[];
            //
            DistributeLayer.prototype.initialize.call(this,options);
            //元数据信息；
            this.metaData=this.options.metaData||{};
            delete this.options.metaData;
            //当前级别
            this.currentZoom=this.map.getZoomLevel();
            //
            this.layer=new g2.carto.GroupLayer({
                id:this.options.layerId,
                name:this.options.layerName||'',
                map: this.map,
                layers:[]
            });
            //保存所有的featurelayer对象和renderer，和比例尺范围的符号配置
            this.featureLayersHolder={};
        },
        /***
         * 添加监听
         * @private
         */
        _addListeners:function(){
            //do parent first
            DistributeLayer.prototype._addListeners.call(this);
            //
            this.map.listen('extentchanged',this._getExtentChangeListener());
        },
        /**
         * 移除监听
         * @private
         */
        _removeListeners:function(){
            this.map.off('extentchanged',this._getExtentChangeListener());
            //do parent last
            DistributeLayer.prototype._removeListeners.call(this);
        },
        _getExtentChangeListener:function(){
            if(!this._extentChangeListener){
                var self=this;
                /****
                 * 此处需要更新当前视野范围内的符号
                 * @param left
                 * @param top
                 * @param right
                 * @param bottom
                 * @private
                 */
                this._extentChangeListener=function(event) {
                    var currentZoom=self.map.getZoomLevel();
                    //update current zoom
                    self.updateSymbol(currentZoom);
                    self.currentZoom=currentZoom;
                }
            }
            return this._extentChangeListener;
        },
        /**
         *
         * @returns {layer.mapClickListener|*}
         * @private
         */
        _getMapClickListener:function(){
            if(!this._mapClickListener){
                var self=this;
                this._mapClickListener=function(){
                    // var ele=self.layer.hitTest(screenX,screenY);
                    // ele=ele.element;
                    // ele.symbol.markerSymbol.fillColor=new g2.sfs.Color({"a": 153, "r": 255, "g": 255, "b": 255});
                    // self.layer.update(ele,true);
                };
            }
            return this._mapClickListener;
        },
        /**
         * 批量添加点
         * @method
         * @memberOf G.lys.FeaturePointLayer.prototype
         * @param {Array} dataArr - 必填，数据数组
         * @param {Object} options - 可选
         * @param {Number} options.dataSpatialReference -可选，数据的坐标系，默认为图层的坐标系
         */
        addElements:function(dataArr,options){
            if(!dataArr){
                return;
            }
            options=options||{};
            var metaFields =this._getFields(this.metaData);
            this.metaFields=metaFields;
            //
            var cost=0,cost1=0,d1,d2,start,end;
            start=new Date().getTime();
            //
            var len=dataArr.length,fLen=metaFields.getCount(),
                zoom=this.map.getZoomLevel(),
                attributeField=this.options.attributeField,
                spatialReference=this.options.spatialReference,
                dataSpatialReference=options.dataSpatialReference||
                    this.options.dataSpatialReference;
            //
            for(var i=0;i<dataArr.length;i++){
                var data=dataArr[i];
                var geom=this._getGeometry(data,dataSpatialReference,spatialReference);
                if(!this.validateGeometry(geom)){
                    this.noneSpatialArr.push(data);
                    continue;
                }

                var values=[],key,attrVals;
                if(attributeField){
                    attrVals=data[attributeField]||{};
                }else{
                    attrVals=data;
                }
                //
                for(var k=0;k<fLen;k++){
                    var field=metaFields.fields[k];
                    var value=new g2.sfs.Value();
                    value.setValue(attrVals[field.name]||null);
                    values.push(value);
                }
                //
                var objectId=this._getRecordId(data);
                //创建要素实例
                var feature = new g2.sfs.Feature({
                    fields: metaFields,   //字段集合
                    values: values,  //字段值集合
                    geometry: geom,     //支持面
                    objectId: objectId    //唯一标识
                });
                //挂接属性
                feature._data=data;
                //
                this.features.push(feature);
                //
                d1=new Date().getTime();
                var symbol=this._getSymbol(attrVals,zoom);
                d2=new Date().getTime();
                cost+=d2-d1;
                //添加要素
                this._addFeature(feature,symbol);
            }
            LoggerUtil.info('feature count :'+len);
            LoggerUtil.info('fetch symbol costs :'+cost);
            //批量添加要素到图层
            this._addFeatures2Layer();
            //渲染图层显示
            this._updateFeatureLayers({
                visible:true
            });
            //notify symbol updated
            this._onSymbolsUpdated();
            //notify elements changed
            this._onElementChanged();
            //
            end=new Date().getTime();
            LoggerUtil.info('total costs :'+(end-start));
        },
        /**
         * 添加feature到featureSet
         * @param feature
         * @param symbolObj
         * @private
         */
        _addFeature:function(feature,symbolObj){
            if(symbolObj&&symbolObj.symbol){
                var symbolKey=symbolObj.symbolKey||this.options.defaultSymbolKey;
                var layerObj=this.featureLayersHolder[symbolKey]||{},
                    layer=layerObj.layer;
                if(!layer){//如果图层还未创建
                    layer = new g2.carto.FeatureLayer({
                        map: this.map,
                        visible: false,
                        cache:true
                    });
                    this.layer.addLayer(layer);
                    var renderer = new g2.render.SimpleRenderer({symbol: symbolObj.symbol});
                    //
                    layerObj={
                        renderer:renderer,
                        layer:layer,
                        zoomRanges:symbolObj.zoomRanges
                    };
                    this.featureLayersHolder[symbolKey]=layerObj;
                }
                if(!layerObj.featureSet){
                    layerObj.featureSet=new g2.sfs.FeatureSet({
                        fields:this.metaFields
                    });
                }
                layerObj.featureSet.add(feature);
            }
        },
        /**
         * 添加要素到图层，显示
         * @param opts
         * opts.show true显示
         * @private
         */
        _addFeatures2Layer:function(){
            for(var key in this.featureLayersHolder){
                var layerObj=this.featureLayersHolder[key],
                    featureSet=layerObj.featureSet,
                    layer=layerObj.layer;
                layerObj.featureSet=null;
                if(featureSet){
                    layer.addFeatures(featureSet);
                }
            }
        },
        /**
         * 更新要素图层
         * @param opts
         * opts.visible true显示
         * @private
         */
        _updateFeatureLayers:function(opts){
            opts=opts||{};
            var key,visible=opts.visible||false;
            for(key in this.featureLayersHolder){
                var layerObj=this.featureLayersHolder[key];
                if(visible){
                    if(layerObj){
                        layerObj.layer.setVisible(true);
                        layerObj.layer.render(layerObj.renderer);
                    }
                }else{
                    layerObj.layer.setVisible(false);
                }
            }
            this.layer.setVisible(visible);
        },
        /**
         * 获取字段信息
         * @param metaData
         * @private
         */
        _getFields:function(metaData){
            var fields = new g2.sfs.Fields();
            if(metaData){
                var metaFields=metaData.model||[],len=metaFields.length;
                for(var i=0;i<len;i++){
                    var metaField=metaFields[i];
                    if(!metaField){
                        continue;
                    }
                    var field=new g2.sfs.Field({
                        name: metaField.fieldName,
                        alias: metaField.fieldNote,
                        dataType:metaField.fieldType,
                        isShape:false
                    });
                    fields.add(field);
                }
            }
            return fields;
        },
        /**
         * 获取指定元素的符号；如果不存在或者符号为空 返回null
         * @method
         * @memberOf G.lys.FeaturePointLayer.prototype
         * @param {String} id - 必填，元素id
         * @returns {*}
         */
        getElementSymbol:function(id){
            var key,objs=this.featureLayersHolder;
            for(key in objs){
                var obj=objs[key];
                if(obj){
                    var layer=obj.layer,
                        renderer=obj.renderer;
                    if(layer&&renderer){
                        var features =layer.features;
                        for(var k=0,len=features.length;k<len;k++){
                            var feature=features[k];
                            if(feature&&feature.objectId==id){
                                return renderer.symbol;
                            }
                        }
                    }
                }
            }
            return null;
        },
        /**
         * 更新图标
         * @method
         * @memberOf G.lys.FeaturePointLayer.prototype
         * @param {Number} zoom - 地图缩放级别
         */
        updateSymbol:function(zoom){
            var key,holder=this.featureLayersHolder,
                updateCount=0;
            for(key in holder){
                //符号不根据比例尺变化
                if(key.indexOf('zoomLevel$=$')<0){
                    continue;
                }
                var obj=holder[key],
                    arr0=key.split('$_$'),
                    zoomEq=arr0[arr0.length-1],
                    lastZoomRange=zoomEq.split('$=$')[1],
                    zoomRanges=obj.zoomRanges,
                    symbolKeyArr=arr0.slice(0,arr0.length-1);
                var currentZoomRange;
                for(var i=0,len=zoomRanges.length;i<len;i++){
                    var rangeStr=zoomRanges[i];
                    if(CommonUtil.assertWithin(zoom,rangeStr)){
                        currentZoomRange=rangeStr;
                        symbolKeyArr.push('zoomLevel$=$'+rangeStr);
                        break;
                    }
                }
                //符号还没变化
                if(currentZoomRange==lastZoomRange){
                    continue;
                }
                //
                var symbolKey=symbolKeyArr.join('$_$'),
                currentSymCfg=this._getSymbolObjByKey(symbolKey);
                //
                var renderer = new g2.render.SimpleRenderer({symbol: currentSymCfg.symbol});
                obj.renderer=renderer;
                obj.layer.render(obj.renderer);
                //更新key值
                delete holder[key];
                holder[currentSymCfg.symbolKey]=obj;
                //
                updateCount++;
            }
            //notify symbol updated
            if(updateCount>0){
                this._onSymbolsUpdated();
            }
        },
        /**
         * 创建符号
         * @param type
         * @param options
         * @returns {*}
         * @private
         */
        _createSymbol:function(type,options){
            return DistributeLayer.prototype._createSymbol.call(this,type,options);
        },
        /**
         * 移除要素
         * @method
         * @memberOf G.lys.FeaturePointLayer.prototype
         * @params {Array} - features features arrary or feature objectid arr;
         */
        removeElements:function(features){
            if(CommonUtil.isArray(features)){
                for(var i=features.length-1;i>=0;i--){
                    var feature=features[i],
                        objectId;
                    //get objectid
                    if(typeof feature=='string'){
                        objectId=feature;
                    }else{
                        objectId=feature.objectId;
                    }
                    var object=this._getLayerElementById(this.layer,objectId);
                    if(object){
                        if(object.layer&&object.element){
                            try{
                                object.layer.remove(object.element);
                            }catch(e){
                                LoggerUtil.warn('fail to delete feature with objectId:'+objectId +'!');
                            }
                        }
                    }
                }
                //notify symbol updated
                this._onSymbolsUpdated();
                //notify elements changed
                this._onElementChanged();
            }
        },
        /**
         * 符号更新了,更新当前的符号数组
         * @private
         */
        _onSymbolsUpdated:function(){
            var holders=this.featureLayersHolder,
                k,arr=[];
            for(k in holders ){
                var holder=holders[k];
                if(holder){
                    var layer=holder.layer;
                    if(layer&&layer.visible&&layer.features.length>0){
                        var object=this._getSymbolObj(k);
                        if(object){
                            arr.push(object);
                        }
                    }
                }
            }
            //clear current
            this.currentSymbols=null;
            this.currentSymbols=arr;
            //invoke callback
            this.invokeCallback('symbolUpdateCallback',{
                layerId:this.options.layerId,
                symbols:arr
            });
        },
        /**
         * @method
         * @private
         */
        hitTest:function(screenX, screenY){
            var layer=this.getLayer();
            var array=[];
            if(layer&&layer.visible){
                if(layer instanceof g2.carto.GroupLayer){
                    var groupLayers=layer.groupLayers;
                    for(var k=groupLayers.length-1;k>=0;k--) {
                        var groupedLayer = groupLayers[k];
                        doHitTest(groupedLayer,screenX,screenY,array);
                    }
                }else{
                    doHitTest(layer,screenX,screenY,array);
                }
            }
            function doHitTest(layer,screenX, screenY,array){
                var ele=layer.hitTest(screenX, screenY);
                if(ele){
                    array.push(ele);
                }
            }
            return array[0]||undefined;
        },
        /**
         * 获取元素
         * @method
         * @memberOf G.lys.FeaturePointLayer.prototype
         * @returns {Array}
         */
        getElements:function(){
            return this.features;
        },
        /**
         * 清空图层
         * @method
         * @memberOf G.lys.FeaturePointLayer.prototype
         */
        clear:function(){
            this.features=[];
            var layers=this.layer.groupLayers;
            for(var k=0,len=layers.length;k<len;k++){
                var layer=layers[k];
                layer&&layer.clear&&layer.clear();
            }
            //
            DistributeLayer.prototype.clear.call(this);
        },
        /**
         * 销毁方法
         * @method
         * @memberOf G.lys.FeaturePointLayer.prototype
         */
        destroy:function(){
            DistributeLayer.prototype.destroy.call(this);
        }
    });
    /**
     * 定义图层类型
     */
    Object.defineProperty(layer,'type',{
        value:12,
        configurable:false,
        writable:false
    });
    return layer;
});
